import { Box } from '@mui/material';
import React from 'react';
import ResponsiveCarousel from '../../components/MemeCorousel';
import AcademicFoundation from '../../components/AcademicFoundation';

const Meme = () => {
  return (
    <Box sx={{ background: '#E4D2BA' }}>
      <Box>
        <ResponsiveCarousel />
      </Box>

      <Box>
        <AcademicFoundation />
      </Box>
    </Box>
  );
};

export default Meme;
